import { render, staticRenderFns } from "./saisie-synthese-modal.vue?vue&type=template&id=45c5b2ad&scoped=true"
import script from "./saisie-synthese-modal.vue?vue&type=script&lang=js"
export * from "./saisie-synthese-modal.vue?vue&type=script&lang=js"
import style0 from "./saisie-synthese-modal.vue?vue&type=style&index=0&id=45c5b2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5b2ad",
  null
  
)

export default component.exports